import { request } from '../core';

export class SettlementStatementApi {
  /**
   * 3.1. 分页获取结算单列表 (Get Settlement Page List)
   */
  static getSettlementPageList(params: {
    pageNum: number;
    pageSize: number;
    number?: string;
    deviceName?: string;
    stationBaseId?: string;
    oemId?: number;
    serviceStationId?: number;
    reportStartTime?: string;
    reportEndTime?: string;
  }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/settlement/get_settlement_page_list',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  /**
   * 3.2. 获取费用明细详情 (Get Cost Details)
   */
  static getSettlementDetail(params: { number: string }): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/settlement/get_settlement_detail',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }

  static submitSettlementDetail(
    params:
      | {
          number: string;
          laborCostList: {
            serviceProject: string;
            cost: number;
            costType: string;
            remark: string;
          }[];
          serviceCostList: {
            serviceProject: string;
            cost: number;
            costType: string;
            remark: string;
          }[];
          otherCostList: {
            serviceProject: string;
            cost: number;
            costType: string;
            remark: string;
          }[];
          requireHardwareModelInfoList: {
            oldHardwareModelId: number;
            newHardwareModelId: number;
            newHardwareModelNumber: string;
            newHardwareModelCount: number;
            newHardwareModelCost: number;
            costType: string;
            remark: string;
          }[];
        }
      | any,
  ): Promise<any> {
    const requestOptions: RequestOptions = {
      path: '/k2/management/require/settlement/edit_settlement',
      method: 'POST',
      body: params,
    };
    return request(requestOptions);
  }
}
